export default {
  filtersList: state => state.filtersList,
  items: state => state.items,
  job_id: state => state.track?.job_id || null,
  limit: state => state.options.limit,
  loading: state => state.loading,
  more: state => state.more,
  numbers: state => state.numbers,
  options: state => state.options,
  page: state => state.page,
  pageLoaded: state => state.pageLoaded,
  selectedFrame: state => state.selectedFrame,
  total: state => state.total,
  track: state => state.track,
  track_id: state => state.track?.track_id || null,
  view: state => state.view,
  visible: state => state.visible,
};
